// Utility to group and sort rows by Brisbane local date
export function groupRowsByBrisbaneDate(rows, getBrisbaneEventDate, formatDisplayDate) {
  // Sort all rows by Brisbane local start time
  const sortedRows = [...rows].sort((a, b) => {
    const aDateTime = getBrisbaneEventDate(a);
    const bDateTime = getBrisbaneEventDate(b);
    return aDateTime - bDateTime;
  });
  // Then group by Brisbane local date string
  return sortedRows.reduce((acc, row) => {
    const brisbaneDate = getBrisbaneEventDate(row);
    const yyyy = brisbaneDate.getFullYear();
    const mm = String(brisbaneDate.getMonth() + 1).padStart(2, '0');
    const dd = String(brisbaneDate.getDate()).padStart(2, '0');
    const localDateStr = `${yyyy}-${mm}-${dd}`;
    const displayDate = formatDisplayDate(localDateStr);
    if (!acc[displayDate]) acc[displayDate] = [];
    acc[displayDate].push(row);
    return acc;
  }, {});
}
